
import Converter from "@/components/Converter";

const Index = () => {
  return <Converter />;
};

export default Index;
